import { useState, useCallback, useEffect } from 'react';
import type { ConversationItem } from '../../types/conversationItem.types';

export const useCoachFeedback = () => {
  const [coachMessages, setCoachMessages] = useState<ConversationItem[]>([]);
  const [showCoachPanel, setShowCoachPanel] = useState(() => window.innerWidth >= 768);

  useEffect(() => {
    const handleResize = () => {
      setShowCoachPanel(window.innerWidth >= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const addCoachMessage = useCallback((message: ConversationItem) => {
    setCoachMessages((prev) => [...prev, message]);
  }, []);

  const toggleCoachPanel = useCallback(() => {
    setShowCoachPanel((prev) => !prev);
  }, []);

  const clearCoachMessages = useCallback(() => {
    setCoachMessages([]);
  }, []);

  return {
    coachMessages,
    addCoachMessage,
    showCoachPanel,
    toggleCoachPanel,
    clearCoachMessages,
  };
};
